import { getCategoryDetails } from "./";
import { selectSearchRequestQuery } from "../../search/domains/selectors/shared";
import getMatchedSeoImportantFacet from "../../../../helpers/getMatchedSeoImportantFacet";

const hasNonEmptyHeaderBody = (headerBody) => Boolean(headerBody?.trim());

export default (state) => {
  const categoryDetails = getCategoryDetails(state);
  const { refine } = selectSearchRequestQuery(state);
  const matchedSeoImportantFacet = getMatchedSeoImportantFacet({
    seoImportantFacets: categoryDetails?.seoImportantFacets,
    refine,
  });

  if (matchedSeoImportantFacet) {
    return hasNonEmptyHeaderBody(matchedSeoImportantFacet.headerBody)
      ? matchedSeoImportantFacet.headerBody
      : undefined;
  }

  return categoryDetails?.headerBody;
};
